
import {useState,useEffect} from 'react'
import {useNavigate , useLocation} from "react-router-dom";
import SendData from "./SendData"
import socket from './../socket.js'

function ErrorSetting (){
  const location = useLocation ();
  const navigate = useNavigate ();

  const [max_temp,setMax_temp]=useState (location.state.max_temp+'');
  const [min_temp,setMin_temp]=useState (location.state.min_temp+'');
  const [max_humid,setMax_humid]=useState (location.state.max_humid+'');
  const [min_humid,setMin_humid]=useState (location.state.min_humid+'');


  useEffect (()=>{
  return () =>{
    socket.off ('message');
  };
},[socket]);

  return (
    <div style={style.container}>
      <div style={style.content}>
        <h2 style={style.text}>
        بیشترین دما :
        </h2>
        <input style={style.input}
        type="tel"
        placeholder = ""
        value={max_temp}
        onChange = {(e)=>{setMax_temp (e.target.value)}}/>
    </div>


    <div style={style.content}>
      <h2 style={style.text}>
      کمترین دما :
      </h2>
      <input style={style.input}
      type="tel"
      placeholder = ""
      value={min_temp}
      onChange = {(e)=>{setMin_temp (e.target.value)}}/>
  </div>

  <div style={style.content}>
    <h2 style={style.text}>
    بیشترین رطوبت:
    </h2>
    <input style={style.input}
    type="tel"
    placeholder = ""
    value={max_humid}
    onChange = {(e)=>{setMax_humid (e.target.value)}}/>
  </div>

  <div style={style.content}>
    <h2 style={style.text}>
    کمترین رطوبت :
    </h2>
    <input style={style.input}
    type="tel"
    placeholder = ""
    value={min_humid}
    onChange = {(e)=>{setMin_humid (e.target.value)}}/>
  </div>

  <button className="btn"
      onClick ={()=>{
      socket.off ('message');
      socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="SAVE_MENU_ERR" && JSON.parse(data).data==true)
            {
              window.alert ('اطلاعات با موفقیت ذخیره شد');
              socket.off ('message');
              navigate (-1);
            }
        });

        SendData (socket,'data',{
          "event":"set_menu_err",
          "data":{
            "max_temp":max_temp,
            "min_temp":min_temp,
            "max_humid":max_humid,
            "min_humid":min_humid
          }
        });
      }}>
       تایید
    </button>
    </div>
  );


}
const style={
  container:{
    width:"90%",
    minHeight:"100vh",
//    display:"flex",
    alignItems:"center",
    padding:10,

//    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
     maxWidth:820,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10,
    padding:10,
    backgroundColor:"#00afff",
    borderRadius:8
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:20,
    borderRadius:8,
    textAlign:"center"
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:820,
    padding:4,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
    padding:0,
    margin:10,
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default ErrorSetting;
